<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getCollectioConfigs('status')"
        style="margin-right: 20px"
        >搜索</el-button>
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button>
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600">
      <el-table-column prop="id" label="id" align="center">
      </el-table-column>
      <el-table-column prop="name" label="名称" align="center">
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center">
      </el-table-column>
      <el-table-column
        prop="enabled"
        label="状态"
        align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.enabled">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="deleted"
        label="是否删除"
        align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.deleted">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center">
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center">
        <template slot-scope="scope">
          <span>{{ initTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="200"
        fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      class="editDialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px">
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item label="名称" prop="name">
          <el-input style="width: 360px" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input style="width: 360px" v-model.number="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="enabled">
          <el-select
            style="width: 360px"
            v-model="form.enabled"
            placeholder="请选择是否启用">
            <el-option key="启用" label="启用" :value="true"></el-option>
            <el-option key="禁用" label="禁用" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="dialogTitle === '编辑'" label="是否删除" prop="deleted">
          <el-select
            style="width: 360px"
            v-model="form.deleted"
            placeholder="请选择是否启用">
            <el-option key="是" label="是" :value="true"></el-option>
            <el-option key="否" label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { validatorIndex, uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
export default {
 
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 30,
        sort: [
          {
            sortKey: "sort",
            sortVal: 1,
          },
        ],
      },
      form: {
        name: undefined,
        deleted: undefined,
        enabled: undefined,
        sort: undefined,
      },
      dialogVisible: false,
      dialogTitle: "",
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        deleted: [
          { required: true, message: "请选择删除状态", trigger: "blur" },
        ],
        enabled: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
        sort: [{ validator: validatorIndex, trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCollectioConfigs();
  },
  methods: {
    // 请求列表
    getCollectioConfigs(type) {
      this.loading = false;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getCollectioConfigList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增专题配置
    addAndEdit(param) {
      this.dialogVisible = true; // 打开新增、编辑对话框
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.form.sort = param.sort;
        this.form.enabled = param.enabled;
        this.form.deleted = param.deleted;
      }
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.addOption();
        } else {
          return false;
        }
      });
    },
    addOption() {
      const addData = {
        name: this.form.name,
        sort: this.form.sort,
        enabled: this.form.enabled,
        deleted: this.form.deleted,
      };
      API.addCollectioConfig(addData).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "新增成功",
          });
          this.dialogVisible = false;
          this.getCollectioConfigs();
        } else {
          this.$message({
            type: "error",
            message: res.tip || res.msg || "新增失败",
          });
        }
        this.handleClose();
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.editOption();
        } else {
          return false;
        }
      });
    },
    editOption() {
      API.updateCollectioConfig(this.form).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "编辑成功",
          });
          this.dialogVisible = false;
          this.getCollectioConfigs();
        } else {
          this.$message({
            type: "error",
            message: res.tip || res.msg || "编辑失败",
          });
        }
        this.handleClose();
      });
    },
    // 删除方法
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color: blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delCollectioConfig(delData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败!",
                });
              }
              this.getCollectioConfigs();
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = undefined;
      this.form.deleted = undefined;
      this.form.sort = undefined;
      this.form.enabled = undefined;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getCollectioConfigs();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getCollectioConfigs();
    },
    // 更换时间格式
    initTime(time) {
      return uniteDate(time);
    },
  },
};
</script>

<style lang="scss" scoped>
.editDialog {
  .el-form-item {
    display: flex;
    .el-form-item__content {
      width: 200px;
    }
  }
}

.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.clickNumDialog {
  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
  /deep/ .el-pagination {
    float: none;
    text-align: right;
    margin-top: 30px;
  }
}
</style>
